/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerClassStudentDropDownViewModelPaginatedResponse } from "../types/BannerClassStudentDropDownViewModelPaginatedResponse.ts";
import { bannerClassStudentDropDownViewModelSchema } from "./bannerClassStudentDropDownViewModelSchema.ts";

export const bannerClassStudentDropDownViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => bannerClassStudentDropDownViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<BannerClassStudentDropDownViewModelPaginatedResponse>;
